import { DateTimeFormatOptions } from 'vue-i18n';

const longDateTime = (timeZone?: string): DateTimeFormatOptions => ({
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  weekday: 'short',
  hour: 'numeric',
  minute: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

const shortDateTime = (timeZone?: string): DateTimeFormatOptions => ({
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

const shortDate = (timeZone?: string): DateTimeFormatOptions => ({
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

const shortDateOfYear = (timeZone?: string): DateTimeFormatOptions => ({
  month: 'short',
  day: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

const time = (timeZone?: string): DateTimeFormatOptions => ({
  hour: 'numeric',
  minute: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

export const shortDateNumeric = (timeZone?: string): DateTimeFormatOptions => ({
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  ...(timeZone ? { timeZone } : {}),
});

const dateTimeFormatters = {
  time,
  shortDate,
  shortDateTime,
  longDateTime,
  shortDateOfYear,
  shortDateNumeric,
};

export type DateTimeFormatter = keyof typeof dateTimeFormatters;

const formatters = (timeZone?: string) => ({
  time: time(timeZone),
  shortDate: shortDate(timeZone),
  shortDateTime: shortDateTime(timeZone),
  longDateTime: longDateTime(timeZone),
  shortDateOfYear: shortDateOfYear(timeZone),
  shortDateNumeric: shortDateNumeric(timeZone),
});

const formatters24h = (timeZone?: string) => ({
  time: { ...time(timeZone), hour12: false },
  shortDate: shortDate(timeZone),
  shortDateTime: { ...shortDateTime(timeZone), hour12: false },
  longDateTime: { ...longDateTime(timeZone), hour12: false },
  shortDateOfYear: shortDateOfYear(timeZone),
  shortDateNumeric: shortDateNumeric(timeZone),
});

export const dateTimeFormats = (timeZone?: string) => ({
  da: formatters24h(timeZone),
  de: formatters24h(timeZone),
  en: formatters(timeZone),
  'en-GB': formatters24h(timeZone),
  es: formatters24h(timeZone),
  fi: formatters24h(timeZone),
  fr: formatters24h(timeZone),
  it: formatters24h(timeZone),
  nl: formatters24h(timeZone),
  pl: formatters24h(timeZone),
  'pt-BR': formatters(timeZone),
  sv: formatters24h(timeZone),
  tr: formatters24h(timeZone),
  cs: formatters24h(timeZone),
  hu: formatters24h(timeZone),
  sk: formatters24h(timeZone),
  sr: formatters24h(timeZone),
  ro: formatters24h(timeZone),
  sl: formatters24h(timeZone),
  bg: formatters24h(timeZone),
  hr: formatters24h(timeZone),
  'zh-CN': formatters24h(timeZone),
});
